module.exports = __webpack_public_path__ + "421756d722cb3dbcbdf8c07ca0aa6a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NonAuthHomePage/components/Description/images/mob1_2x.png
// module id = Edjd
// module chunks = 13